import { t } from '@lingui/macro';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import styles from './PageNotFound.module.css';

export const PageNotFound = () => (
    <div className={styles.pageWrapper}>
        <h2>404</h2>
        <Button
            type='link'
            to='/'
            component={Link}
        >
            {t`Вернуться на главную страницу`}
        </Button>
    </div>
);


